import { lazy, Suspense, useEffect } from 'react';

import { PageLayout } from '~components/page/PageLayout';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import { selectAddonsIsTankLabellingEnabled } from '~store/selectors';

const TankLabelingExtension = lazy(() => import('~extension/tank-labelling/TankLabeling'));

export default function TankLabellingPage() {
  const { hlPageTruckLabeling } = useLabels(['hlPageTruckLabeling']);
  const navigateToDefault = useNavigateToDefault();
  // read store values
  const isEnabled = useAppSelector(selectAddonsIsTankLabellingEnabled);

  useEffect(() => {
    if (!isEnabled) {
      navigateToDefault();
    }
  }, [isEnabled, navigateToDefault]);

  return (
    <PageLayout title={hlPageTruckLabeling} className="page--truck-labeling">
      <div className="c-view__content relative flex-grow overflow-hidden">
        <div className="h-full">
          <Suspense fallback="loading">
            <TankLabelingExtension />
          </Suspense>
        </div>
      </div>
    </PageLayout>
  );
}
